class MilletSlider extends HTMLElement {
  constructor() {
    super()
    this.swiper = null
    this.resizeTimer = null
  }

  connectedCallback() {
    // Wait a moment for Shopify/Liquid markup rendering
    requestAnimationFrame(() => {
      this.initSwiper()
      this.bindResizeHandler()
    })
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true)
    }

    window.removeEventListener("resize", this.resizeHandler)
  }

  getSpaceBetween() {
    const width = window.innerWidth

    if (width >= 1024) return 60
    if (width >= 769) return 40
    if (width >= 481) return 30
    return 20
  }

  initSwiper() {
    const target = this.querySelector("#milletSwiper")
    if (!target) return

    const SwiperLib = window.Swiper
    if (!SwiperLib) {
      console.warn("Swiper library missing!")
      return
    }

    this.swiper = new SwiperLib("#milletSwiper", {
      loop: true,
      centeredSlides: true,
      slidesPerView: "auto",
      spaceBetween: this.getSpaceBetween(),
      speed: 300,
      grabCursor: true,

      navigation: {
        nextEl: this.querySelector("#milletNavRight"),
        prevEl: this.querySelector("#milletNavLeft"),
      },

      mousewheel: {
        invert: false,
        forceToAxis: true,
        sensitivity: 1,
      },

      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },

      breakpoints: {
        481: { spaceBetween: 30 },
        769: { spaceBetween: 40 },
        1024: { spaceBetween: 60 },
      },
    })
  }

  bindResizeHandler() {
    this.resizeHandler = () => {
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => {
        if (this.swiper) {
          this.swiper.params.spaceBetween = this.getSpaceBetween()
          this.swiper.update()
        }
      }, 250)
    }

    window.addEventListener("resize", this.resizeHandler)
  }
}

customElements.define("millet-slider", MilletSlider)